var baseStyle = {
  color: 'white',
  fontFamily: 'body',
  lineHeight: 'body',
  boxSizing: 'border-box',
  borderRadius: 'sm',
  shadow: 'sm',
  fontSize: 'xs',
  fontWeight: 'semibold',
  textAlign: 'center',
  py: 1,
  px: 2,
  '.chakra-icon': {
    top: '-1px',
    position: 'relative',
    fontSize: 'md'
  }
};
function variantSolid(props) {
  var c = props.colorScheme;
  return {
    bg: "".concat(c, ".400")
  };
}
var variants = {
  solid: variantSolid
};
var sizes = {};
var defaultProps = {
  variant: 'solid',
  colorScheme: 'blue'
};
var Badge = {
  baseStyle: baseStyle,
  variants: variants,
  sizes: sizes,
  defaultProps: defaultProps
};
export { Badge as default };